import { BaseEntity, JsonApiRelationship, JsonApiResource } from '../../jsonapi-provider';
import Customer from '../customer';
import type Site from '../site';

@JsonApiResource({
  type: 'invoice-configuration',
})
export default class InvoiceConfiguration extends BaseEntity {
  @JsonApiRelationship('site') sites: Site[] = [];
  @JsonApiRelationship('customer') customer: Customer | null = null;

  constructor(
    id: InvoiceConfiguration['id'] = undefined,
    public name: string = '',
    public invoiceNumberPrefix: string = '',
    public recipientsList: string[] = [],
    sites: InvoiceConfiguration['sites'] = [],
    customer: InvoiceConfiguration['customer'] = new Customer()
  ) {
    super();
    this.id = id;
    this.sites = sites;
    this.customer = customer;
  }
}
